import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { DateFormats, formatDate, parseDate } from 'src/utils/time';
import { MessageAuthorAndTimeStyled } from './MessageAuthorAndTime.styles';

interface MessageAuthorAndTimeProps {
  timestamp: string;
  author: string;
  translated?: boolean;
  deleted?: boolean;
  deletedBy?: string;
}

export const MessageAuthorAndTime: React.FC<MessageAuthorAndTimeProps> = ({
  timestamp,
  author,
  translated,
  deleted,
  deletedBy,
}) => {
  const { t } = useTranslation();
  const parsedTimestamp = parseDate(timestamp, DateFormats.ISO);

  const translatedMessageLabel = t(
    'public.ChatContainer.translatedMessageLabel',
  );

  const authorLabel =
    author === 'Anonymous' ? t('public.ChatContainer.anonymousLabel') : author;

  const getAuthorText = () => {
    if (deleted || deletedBy) {
      return t('public.ChatContainer.deletedByMessage', {
        author: deletedBy,
      });
    } else {
      return authorLabel;
    }
  };

  return (
    <MessageAuthorAndTimeStyled>
      {getAuthorText()}
      {' | '}
      {formatDate(parsedTimestamp, DateFormats.TIME_SHORT, false)}
      {' | '}
      {formatDate(parsedTimestamp, DateFormats.DAY_MONTH_YEAR, false)}
      {translated && ` | ${translatedMessageLabel}`}
    </MessageAuthorAndTimeStyled>
  );
};
